<template>
  <div class="user-tab column" :class="showMenu ? 'close' : ''">
    <div class="info row align-center" @click="showMenu = !showMenu">
      <Avatar>
        <img v-if="
          user.link_foto_doutor &&
          user.perfil == 'doutor' &&
          user.link_foto_doutor != '/img/img_usuario_padrao.png'
        " :src="user.link_foto_doutor" />
        <img src="../assets/img/usuario_padrao.png" v-else />
      </Avatar>
      <div class="name column grid">
        <strong>{{ user.nome || "Nome do usuário" }}</strong>
        <br />
        <span class="hide-m">
          ID {{ user.id_doutor || user.id }} -
          <b v-if="user.perfil == 'doutor'">Supporter</b>
          <b v-if="user.perfil == 'funcionario'">{{ user.grupo }}</b>
        </span>
      </div>
      <div>
        <i class="arrow-down fa fa-chevron-down" style="margin-right: 12px"></i>
      </div>
    </div>
    <ul class="user-tab-menu column" :class="user.perfil">
      <router-link v-if="perfil" :to="perfil">
        <li @click="showMenu = false"><i class="fa fa-user"></i> Perfil</li>
      </router-link>
      <router-link v-if="user.perfil == 'doutor'" to="/parceiro/documentos">
        <li @click="showMenu = false">
          <i class="fa fa-folder"></i> Documentos
        </li>
      </router-link>
      <!-- <router-link to="/parceiro/pagamento" v-if="user.perfil == 'doutor'">
        <li @click="showMenu = false">
          <i class="fa fa-dollar-sign"></i> &nbsp;Dados Bancários
        </li>
      </router-link> -->
      <router-link v-if="account" :to="account">
        <li @click="
          showMenu = false;
        clearMenu();
        ">
          <i class="fa fa-cog"></i> Conta
        </li>
      </router-link>
      <li @click="SET_LOGOUT()"><i class="fas fa-sign-out-alt"></i> Sair</li>
    </ul>
    <div class="mask" @click="showMenu = false" v-if="showMenu"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Avatar from "@/components/Avatar.vue";
export default {
  name: "UserTab",
  props: {
    perfil: {
      type: String,
    },
    account: {
      type: String,
    },
  },
  components: {
    Avatar,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    ...mapActions("user", ["SET_LOGOUT"]),
    clearMenu() {
      this.$parent.$parent.$children[0].changeMenu("");
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.user-tab {
  height: 70px;
  color: $font-color;
  font-size: 12px;
  overflow: hidden;

  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 900;
  }

  .info {
    margin-top: 15px;
    margin-left: 15px;
    cursor: pointer;
  }

  .name {
    margin-left: 10px;

    @media (max-width: $medium) {
      font-size: 12px;
    }
  }

  &-menu {
    list-style: none;
    margin-top: 100px;
    z-index: 991;
    border-bottom-left-radius: 16px;
    padding: 12px 0px;
    overflow: hidden;
    box-shadow: $shadow;
    border-left: 1px solid #fff;
    border-bottom: 1px solid #fff;
    background: rgba($orange, 0.6);

    li {
      padding: 15px 12px;
      cursor: pointer;
      color: white;
      font-weight: bold;
      flex-direction: row;
      align-items: center;
      letter-spacing: 1.8px;
      text-transform: uppercase;
      font-size: 11px;

      @media (max-width: $large) {
        font-size: 9px;
        min-width: 200px;
      }

      i {
        margin-right: 5px;
      }
    }
  }

  &.close {
    height: 390px;
  }
}
</style>